import { allowedKeys, type WebLinkConfig } from './const';

export const getWebLinkConfig = (
  config: WebLinkConfig
): Partial<WebLinkConfig> => {
  return Object.fromEntries(
    allowedKeys
      .filter(key => config[key] !== undefined)
      .map(key => [key, config[key] as WebLinkConfig[typeof key]])
  ) as Partial<WebLinkConfig>;
};
